"use client";

import { Slider } from "@base-ui/react/slider";
import { cn } from "cn";

function SliderComponent({ className, ...props }: Slider.Root.Props<number>) {
  return (
    <Slider.Root
      className={cn("flex w-full touch-none flex-col gap-4", className)}
      thumbAlignment="edge"
      {...props}
    >
      <Slider.Control className="flex h-4 w-full items-center">
        <Slider.Track
          className="flex h-2 w-full grow rounded-full bg-gray-300"
          style={{ boxShadow: "inset 0 0 0 1px var(--color-gray-400)" }}
        >
          <Slider.Indicator className="rounded-full bg-gray-1200" />
          <Slider.Thumb
            className="relative flex size-4 items-center justify-center outline-none transition-transform duration-150 ease-out before:absolute before:-inset-3 before:content-[''] active:scale-110 disabled:pointer-events-none disabled:opacity-50"
            data-slot="slider-thumb"
          >
            <div className="size-4 rotate-45 rounded bg-surface shadow-ring" />
          </Slider.Thumb>
        </Slider.Track>
      </Slider.Control>
    </Slider.Root>
  );
}

export { SliderComponent as Slider };
